<template>
    <div class="border rounded p-3 mb-3 bg-light">
        <div class="row align-items-center g-2">
            <div class="col-auto">
                <div class="text-muted small">Start odometer</div>
                <div class="fw-bold">{{ startOdometer != null ? startOdometer.toLocaleString() + ' km' : '—' }}</div>
            </div>
            <div class="col text-center text-muted small px-2" style="letter-spacing:0.05em;">
                ── {{ odometerSpan != null ? odometerSpan.toFixed(2) + ' km span' : 'no odometer' }} ──▶
            </div>
            <div class="col-auto text-end">
                <div class="text-muted small">End odometer</div>
                <div class="fw-bold">{{ endOdometer != null ? endOdometer.toLocaleString() + ' km' : '—' }}</div>
            </div>
        </div>

        <template v-if="matchPct !== null && odometerSpan">
            <div class="mt-2 mb-1 d-flex justify-content-between" style="font-size:0.78rem;">
                <span>GPS captured {{ gpsDistance.toFixed(2) }} km of {{ odometerSpan.toFixed(2) }} km odometer span</span>
                <span :class="`badge bg-${accuracyClass(matchPct)}`">{{ accuracyLabel(matchPct) }}</span>
            </div>
            <div class="progress" style="height:8px;">
                <div
                    class="progress-bar"
                    :class="`bg-${accuracyClass(matchPct)}`"
                    :style="{ width: Math.min(matchPct, 100) + '%' }"
                ></div>
            </div>
            <div v-if="matchPct < 75" class="mt-2 text-danger small">
                ⚠ GPS captured less than 75% of the odometer distance. Check for offline periods or signal gaps below.
            </div>
            <div v-else-if="matchPct > 110" class="mt-2 text-info small">
                ℹ GPS distance exceeds odometer. This can happen due to GPS noise or signal bounce, particularly in urban areas.
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
import { accuracyClass, accuracyLabel } from "../composables/useGpsAnalytics";

defineProps<{
    startOdometer: number | null;
    endOdometer: number | null;
    odometerSpan: number | null;
    gpsDistance: number;
    matchPct: number | null;
}>();
</script>
